module.exports = __webpack_public_path__ + "img/NewsCenterDetails4_pic4.e081dd71.png";